export default __webpack_public_path__ + "static/media/review2.86ec569b.png";